
import moment from "moment-timezone"
import geraDataV2 from "../geraDataV2"
import { CHECKLIST_PARAMETROS } from "@/constants/CHECKLIST"

export default function dadosTabelas() {
  /* 
  nomeapi: => { opcional } NOME DA TABELA NA API,
  campoatt: => CAMPO PARA UTILIZAR NA HORA DA ATUALIZACAO,
  prefixo: => PREFIXO DA TABELA LOCAL,
  model =>  MODEL DO BANCO LOCAL,
  */
  return {
    aberturalote: {
      campoatt: 'abldataalteracao',
      prefixo: 'abl',
      model: aberturalote
    },
    turno: {
      campoatt: 'tupdataalteracao',
      prefixo: 'tup',
      model: turno
    },
    localarmazenamento: {
      campoatt: 'loadataalteracao',
      prefixo: 'loa',
      model: localarmazenamento
    },
    produto: {
      campoatt: 'prodataalteracao',
      prefixo: 'pro',
      model: produto
    },
    fabrica: {
      campoatt: 'fabdataalteracao',
      prefixo: 'fab',
      model: fabrica
    },
    producao: {
      nomeapi: 'ordemproducao',
      campoatt: 'prcdataalteracao',
      prefixo: 'prc',
      model: ordemproducao
    },
    apontamentoproducao: {
      campoatt: 'appdataalteracao',
      prefixo: 'app',
      model: apontamentoproducao
    },
    variedade: {
      campoatt: 'vardataalteracao',
      prefixo: 'var',
      model: variedade
    },
    secador: {
      campoatt: 'scddataalteracao',
      prefixo: 'scd',
      model: secador
    },
    abastecimentosecagem: {
      campoatt: 'absdataalteracao',
      prefixo: 'abs',
      model: abastecimentosecagem
    },
    secagem: {
      campoatt: 'secdataalteracao',
      prefixo: 'sec',
      model: secagem
    },
    // amostra: {
    //   nomeapi: 'amostrasecagem',
    //   campoatt: 'amodataalteracao',
    //   prefixo: 'amo',
    //   model: amostrasecagem
    // },
    ordemcarregamento: {
      campoatt: 'orcdataalteracao',
      prefixo: 'orc',
      model: ordemcarregamento
    },
    ordemcarregamentoitem: {
      campoatt: 'ocidataalteracao',
      prefixo: 'oci',
      model: ordemcarregamentoitem
    },
    ordemcarregamentounidade: {
      campoatt: 'ocudataalteracao',
      prefixo: 'ocu',
      model: ordemcarregamentounidade
    },
    empresa: {
      campoatt: 'empdataalteracao',
      prefixo: 'emp',
      model: empresa
    },
    // Checklist offline: `parametros` recorta o delta e o idnuvem por origem.
    formulario: {
      campoatt: 'fordataalteracao',
      prefixo: 'for',
      parametros: CHECKLIST_PARAMETROS,
      model: formulario
    },
    formularioquestao: {
      campoatt: 'foqdataalteracao',
      prefixo: 'foq',
      parametros: CHECKLIST_PARAMETROS,
      model: formularioquestao
    },
    formularioquestaoopcao: {
      campoatt: 'fqodataalteracao',
      prefixo: 'fqo',
      parametros: CHECKLIST_PARAMETROS,
      model: formularioquestaoopcao
    },
    formularioidentificacao: {
      campoatt: 'foidataalteracao',
      prefixo: 'foi',
      parametros: CHECKLIST_PARAMETROS,
      model: formularioidentificacao
    },
    formularioresposta: {
      campoatt: 'frsdataalteracao',
      prefixo: 'frs',
      parametros: CHECKLIST_PARAMETROS,
      model: formularioresposta
    }
  }
}

export function aberturalote(item) {
    return {
        ablidnuvem: item.id,
        ablidaberturalote: item.ablidaberturalote,
        ablnrocontrole: item.ablnrocontrole,
        abldescricao: item.prodescricao,
        ablgranulometria: item.moddescricao,
        abldataalteracao: item.abldataalteracao,
        abldataabertura: item.abldataabertura,
        ablidproduto: item.ablidproduto,
        ablcodigodun: item.ablcodigodun,
    }
}
export function turno(item) {
    return {
        tupidnuvem: item.id,
        tupidturno: item.tupidturno,
        tupdataabertura: item.tupdataabertura,
        tupdatafechamento: item.tupdatafechamento,
        tupobservacao: item.tupobservacao,
        tupdataalteracao: item.tupdataalteracao
    }
}
export function localarmazenamento(item) {
    return {
        loaidnuvem: item.id,
        loaidlocalarmazenamento: item.lmeidlocalmovimentacaoestoque,
        loadescricao: item.lmedescricao,
        loadataalteracao: item.lmedataalteracao,
        loacodigoarmazem: item.lmecodigoarmazem,
        loausadoapppesagem: item.lmeusadoapppesagem,
    }
}
export function produto(item) {
    return {
        proidnuvem: item.id,
        prodescricao: item.prodescricao,
        proidproduto: item.proidproduto,
        prodataalteracao: item.prodataalteracao,
        progranulometria: item.moddescricao,
        proidvariedade: item.proidvariedade,
    }
}
export function fabrica(item) {
    return {
        fabidnuvem: item.id,
        fabidfabrica: item.fabidfabrica,
        fabdescricao: item.fabdescricao,
        fabdataalteracao: item.fabdataalteracao,
    }
}
export function ordemproducao(item) {
    return {
        prcidnuvem: item.id,
        prcidproducao: item.orpidordemproducao,
        prcidfabrica: item.orpidfabrica,
        prcdataabertura: item.orpdataabertura,
        prcdatafechamento: item.orpdatafechamento,
        prcobservacao: item.orpobservacao,
        prcnoordemproducao: item.orpnooremproducao,
        prcdataalteracao: moment.utc(item.orpdataalteracaomoment).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
    }
}
export function apontamentoproducao(item) {
    return {
        appidnuvem: item.id,
        appidaberturalote: item.appidaberturalote,
        appdatapesagem: item.appdatapesagem,
        appobsduplicado: item.appobsduplicado,
        appnumerobag: item.appnumerobag,
        appdataalteracao: item.appdataalteracao,// moment.utc(item.appdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
        appstatus: item.appstatus,
        apppeso: item.apppeso,
        appidlocaltransferenciaproducao: item.appidlocaltransferenciaproducao,
        appidlocalmovimentacaoestoque: item.appidlocalmovimentacaoestoque,
    }
}
export function variedade(item) {
    return {
        varidnuvem: item.id,
        varidvariedade: item.varidvariedade,
        vardescricao: item.vardescricao,
        vardataalteracao: item.vardataalteracao,
    }
}
export function secador(item) {
    return {
      scdidnuvem: item.id,
      scdidsecador: item.scdidsecador,
      scdstatus: item.scdstatus,
      scdperdaumidadehora: item.scdperdaumidadehora,
      scdperdaumidadepercentual: item.scdperdaumidadepercentual,
      scddataalteracao: moment.utc(item.scddataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
  }
}
export function abastecimentosecagem(item) {
    return {
      absidnuvem: item.id,
      absidaberturalote: item.absidaberturalote,
      absidusuario: item.absidusuario,
      absoperador: item.absoperador,
      absidsecador: item.absidsecador,
      absidsecagem: item.absidsecagem,
      abssecagem: item.abssecagem,
      absstatus: item.absstatus,
      absdatainicio: geraDataV2({date:item?.absdatainicio, add: 3}),
      absdatatermino: item.absdatatermino ? geraDataV2({date: item.absdatatermino, add: 3}) : '',
      absdataalteracao: moment.utc(item.absdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
      absdatanuvem: moment.utc(item.absdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
  }
}
export function secagem(item){
  // console.log('ITEM DA SECAGEM QUE ESTÁ VINDO',item, geraDataV2({date:item.secdatainicio, add: 3}))
  return {
    secidnuvem: item.id,
    secdatainicio: geraDataV2({date:item.secdatainicio, add: 3}),
    secstatus: item.secstatus,
    secdatatermino: item.secdatatermino,
    sectempooperacao: item.sectempooperacao,
    sectipooperacao: item.sectipooperacao,
    secidusuario: item.secidusuario,
    secidsecagem: item.secidsecagem,
    secidlocalmovimentacaoestoque: item.secidlocalmovimentacaoestoque,
    secsecador: item.secsecador,
    secidsecador: item.secidsecador,
    secumidade: item.secumidade,
    secumidadefinal: item.secumidadefinal,
    sectemperaturaar: item.sectemperaturaar,
    secumidadear: item.secumidadear,
    secpesoentrada: item.secpesoentrada,
    secdataalteracao: moment.utc(item.secdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
    secdatanuvem: moment.utc(item.secdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
  }
}
export function amostrasecagem(item) {
  console.log('ITEM DA AMOSTRA QUE ESTÁ VINDO',item, geraDataV2({date: item.amsdataoperacao, add: 3}))
  return {
    amoidnuvem: item.id,
    amoidamostra: item.amsidamostra,
    amoidusuario: `${item.amsidusuario}`,
    amostatus: item.amsstatus,
    amofluxoar: item.amsfluxoar,
    amoobservacao: item.amsobservacao,
    amoumidade: item.amsumidade,
    amoumidadecima: item.amsumidadecima,
    amoumidademeio: item.amsumidademeio,
    amoumidadebaixo: item.amsumidadebaixo,
    amodataamostra: geraDataV2({date: item?.amsdataamostra, add: 3}),//geraDataV2(moment.utc(item.amsdataamostra).subtract(3, 'hours')),
    amodatastatus: item.amsdatastatus !== null ? geraDataV2(item.amsdatastatus): null,
    amodataoperacao: geraDataV2({date: item?.amsdataoperacao, add: 3}),//geraDataV2(moment.utc(item.amsdataoperacao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss')),
    amodataalteracao: moment.utc(item.amsdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
    amodatanuvem: moment.utc(item.amsdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'),
  }
}

export function ordemcarregamento(item) {
  // console.log('log item', item)
  return {
    orcidnuvem: item.id,
    orcidordemcarregamento: item.orcidordemcarregamento,
    orcidveiculo: item.orcidveiculo,
    orcplaca: item.orcplaca,
    orcplacacomplementar1: item.orcplacacomplementar1,
    orcplacacomplementar2: item.orcplacacomplementar2,
    orctipomercado: item.orctipomercado,
    orcidpessoatransportador: item.orcidpessoatransportador,
    orcidpessoamotorista: item.orcidpessoamotorista,
    orcobservacao: item.orcobservacao,
    orcidusuarioordem: item.orcidusuarioordem,
    orcdataordem: item.orcdataordem,
    orcdataalteracao: item.orcdataalteracao,
    orcdatafinalizado: item.orcdatafinalizado,
    orcmarca: item.orcmarca,
    orctransportador: item.orctransportador,
    orcmotorista: item.orcmotorista,
    orcdatainicio: item.orcdatainicio,
    orcidusuarioiniciou: item.orcidusuarioiniciou,
    orcidusuariofinalizou: item.orcidusuariofinalizou,
    orcidlocalmovimentacaoestoque: item.orcidlocalmovimentacaoestoque,
    orcdoca: item.orcdoca,
    orcarmazem: item.orcarmazem,
    orcdatafaturamento: item.orcdatafaturamento
  }
}

export function ordemcarregamentoitem(item) {
  return {
    ociidnuvem: item.id,
    ociidordemcarregamentoitem: item.ociidordemcarregamentoitem,
    ociidordemcarregamento: item.ociidordemcarregamento,
    ociquantidade: item.ociquantidade,
    ociidcliente: item.ociidcliente,
    ocicliente: item.ocicliente,
    ociidproduto: item.ociidproduto,
    ociproduto: item.ociproduto,
    ociprodutocodigo: item.ociprodutocodigo,
    ociprodutoexportacao: item.ociprodutoexportacao,
    ocidataalteracao: item.ocidataalteracao,
    ocidatafinalizado: item.ocidatafinalizado,
    ociverificaunidade: item.ociverificaunidade,
    ociun: item.ociun,
  }
}

export function ordemcarregamentounidade(item) {
  return {          
    ocuidnuvem: item.id,      
    ocuidordemcarregamentounidade: item.ocuidordemcarregamentounidade,
    ocuidordemcarregamentoitem: item.ocuidordemcarregamentoitem,
    ocuidaberturalote: item.ocuidaberturalote,
    oculote: item.oculote,
    oculocal: item.oculocal,
    ocuidlocalmovimentacaoestoque: item.ocuidlocalmovimentacaoestoque,
    ocuquantidade: item.ocuquantidade,
    ocudataalteracao:  item.ocudataalteracao,
    ocudatafinalizado : item.ocudatafinalizado,
    ocudatacriacao: item.ocudatacriacao,
    ocuorigem: item.ocuorigem,
    ocunumerobag: item.ocunumerobag
  }
}

export function empresa(item) {
  return {
    empidnuvem: item.id,
    empidempresa: item.empidempresa,
    empnome: item.empnome,
    empcnpj: item.empCNPJ,
    empsafra: item.empsafra,
    empdominiochecklist: item.empdominiochecklist,
    empdataalteracao: item.empdataalteracao
  }
}

/* ----- Checklist offline (espelhos da API) ----- */

export function formulario(item) {
  return {
    foridnuvem: item.id,
    fororigemtipo: item.fororigemtipo,
    fororigemid: item.fororigemid,
    fororigemdados: typeof item.fororigemdados === 'string'
      ? JSON.parse(item.fororigemdados || '{}')
      : (item.fororigemdados ?? {}),
    fornome: item.fornome,
    fordescricao: item.fordescricao,
    fornomeimagem: item.fornomeimagem,
    fordatacadastro: item.fordatacadastro,
    fordatafinalizado: item.fordatafinalizado,
    forexigecpf: item.forexigecpf,
    forcpfpadrao: item.forcpfpadrao,
    forexigenome: item.forexigenome,
    fornomepadrao: item.fornomepadrao,
    forlink: item.forlink,
    fordataalteracao: item.fordataalteracao
  }
}

export function formularioquestao(item) {
  return {
    foqidnuvem: item.id,
    foqidformularionuvem: item.foqidformularionuvem,
    foqidformularioquestaonuvem: item.foqidformularioquestaonuvem,
    foqnome: item.foqnome,
    foqdescricao: item.foqdescricao,
    foqtipo: item.foqtipo,
    foqobrigatorio: item.foqobrigatorio,
    foqordem: item.foqordem,
    foqdataalteracao: item.foqdataalteracao
  }
}

export function formularioquestaoopcao(item) {
  return {
    fqoidnuvem: item.id,
    fqoidformularioquestaonuvem: item.fqoidformularioquestaonuvem,
    fqodescricao: item.fqodescricao,
    fqoordem: item.fqoordem,
    fqodataalteracao: item.fqodataalteracao
  }
}

export function formularioidentificacao(item) {
  return {
    foiidnuvem: item.id,
    foridformulario: item.foridformulario,
    foinome: item.foinome,
    foicpf: item.foicpf,
    foiultimagravacao: item.foiultimagravacao,
    foidatafinalizado: item.foidatafinalizado,
    foichaveenvio: item.foichaveenvio,
    foidataalteracao: item.foidataalteracao
  }
}

// Prefixo local `frs` (na API é `for`, igual ao formulário).
export function formularioresposta(item) {
  return {
    frsidnuvem: item.id,
    frsidformularioidentificacao: item.foridformularioidentificacao,
    frsidformularioquestao: item.foridformularioquestao,
    frsresposta: item.forresposta,
    frsdataalteracao: item.fordataalteracao
  }
}